export class CardAutoSizeMessage{
  public height: number;

  constructor(height: number){
    this.height = height;
  }
}